import { Link } from 'react-router-dom'; // Import Link for navigation
import { colors } from '../colors';
import './Header.css'; // Import the CSS file

const Header = () => {
    return (
        <header className="header" style={{ backgroundColor: colors.backgroundPrimary }}>
            <Link to="/" className="logo-link">Planna</Link>
            <nav className="nav-links">
                {/* <Link to="/for-teachers" className="nav-link">For Teachers</Link>
                <Link to="/for-schools" className="nav-link">For Schools</Link>
                <Link to="/pricing" className="nav-link">Pricing</Link> */}
            </nav>
            <div></div>
            {/* <a
                href="https://app.planna.education"
                className="login-button"
                style={{ backgroundColor: colors.accentPrimary, display: 'inline-block', textAlign: 'center', textDecoration: 'none',  }}
            >
                Login
        </a> */}
        </header >
    );
};

export default Header;
